/* eslint-disable @typescript-eslint/no-explicit-any */

export const isServerSide = (): boolean => {
  return typeof (globalThis as any).window === 'undefined'
}

export const getWindowSearchParams = (): URLSearchParams => {
  const search = (globalThis as any).window?.location.search ?? ''
  return new URLSearchParams(search)
}

export const setGlobalConsole = (console: Console): void => {
  ;(globalThis as any).console = console
}

export const getGlobalConsole = (): Console => {
  return console
}

export const getGlobalLocalStorage = (): Storage | undefined => {
  return (globalThis as any).window?.localStorage
}

export const setGlobalDocumentTitle = (title: string): void => {
  ;(globalThis as any).document.title = title
}

export const addGlobalEventListener = (event: any, callback: () => void): void => {
  ;(globalThis as any).window.addEventListener(event, callback)
}

export const removeGlobalEventListener = (event: any, callback: () => void): void => {
  ;(globalThis as any).window.removeEventListener(event, callback)
}

export const getGlobalHref = (): string | undefined => {
  return (globalThis as any).window?.location?.href
}

export const setGlobalHref = (href: string): void => {
  if ((globalThis as any).window) {
    ;(globalThis as any).window.location.href = href
  }
}

export const getGlobalOrigin = (): string | undefined => {
  return (globalThis as any).window?.location?.origin
}

export const getGlobalNavigator = (): any | undefined => {
  return (globalThis as any).navigator
}

export const writeGlobalClipboardText = async (text: string): Promise<void> => {
  const navigator = getGlobalNavigator()
  if (navigator && navigator.clipboard) {
    await navigator.clipboard.writeText(text)
  } else {
    throw new Error('Clipboard API is not available')
  }
}

export const globalAlert = (message: string): void => {
  ;(globalThis as any).alert(message)
}
